/* Glowraiders gallery tab arrows + buy box tweaks. Works on desktop and mobile, and after theme editor reloads. */
(function () {
  'use strict';
  if (window.GR_GALLERY_TABS) return;
  window.GR_GALLERY_TABS = true;
  /* Buy Now shows just its label (no price) - Kaching shows bundle prices. */
  function plainBuy() {
    document.querySelectorAll('[data-gr-buy="hero"] [data-gr-label]').forEach(function (l) {
      if (l.getAttribute('data-price') === 'false') return;
      l.setAttribute('data-price', 'false');
      var b = l.closest('[data-gr-buy]');
      if (window.GR && window.GR.Product && b) window.GR.Product.label(b, 'idle');
      else if (!b || !b.disabled) l.textContent = l.getAttribute('data-base');
    });
  }
  function update(strip) {
    var bar = strip.closest('[data-gr-thumbsbar]'); if (!bar) return;
    var max = strip.scrollWidth - strip.clientWidth;
    var prev = bar.querySelector('[data-gr-tscroll="-1"]'), next = bar.querySelector('[data-gr-tscroll="1"]');
    if (prev) prev.disabled = strip.scrollLeft <= 2;
    if (next) next.disabled = strip.scrollLeft >= max - 2;
  }
  function all() { document.querySelectorAll('[data-gr-thumbsbar] .gr-thumbs').forEach(update); plainBuy(); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gr-tscroll]'); if (!b) return;
    var bar = b.closest('[data-gr-thumbsbar]'), strip = bar && bar.querySelector('.gr-thumbs'); if (!strip) return;
    var dir = parseInt(b.getAttribute('data-gr-tscroll'), 10);
    strip.scrollBy({ left: dir * Math.max(120, strip.clientWidth * 0.7), behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) { if (e.target && e.target.classList && e.target.classList.contains('gr-thumbs')) update(e.target); }, true);
  window.addEventListener('resize', all);
  var mo = new MutationObserver(function (list) {
    list.forEach(function (m) {
      var t = m.target;
      if (m.type === 'attributes' && t.classList && t.classList.contains('gr-thumb') && t.getAttribute('aria-selected') === 'true') {
        var strip = t.parentElement; if (!strip) return;
        var l = t.offsetLeft - strip.offsetLeft, r = l + t.offsetWidth;
        if (l < strip.scrollLeft || r > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: l - 8, behavior: 'smooth' });
      }
    });
    all();
  });
  function start() { mo.observe(document.body, { attributes: true, attributeFilter: ['aria-selected'], subtree: true, childList: true }); all(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', all);
})();
